import React from 'react';
import { TableView } from '../TableView';
import { HubProposal } from '../../../api/types';
import { createTableColumns } from './tableConfig';
import { ProposalTableProps } from '../../../types';

export const HubTable = ({ tableData, loading, ...actions }: ProposalTableProps<HubProposal>) => {
  const columns = createTableColumns({ tableData, ...actions });

  return (
    <TableView<HubProposal>
      loading={loading}
      columns={columns}
      height="calc(100% - 9rem)"
      tableData={tableData}
      noData="No data about proposals"
      loadingText="Proposals loading..."
    />
  );
};
